var map = {
	"./activity_reports.png": 7268,
	"./admin_reports.png": 8050,
	"./custom_reports.png": 3702,
	"./energy_reports.png": 8607,
	"./operational_reports.png": 2159,
	"./security_reports.png": 8205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2312;